/* import __COLOCATED_TEMPLATE__ from './composer.hbs'; */
/* RESPONSIBLE TEAM: team-workflows */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import createFragmentFromBlock from 'embercom/lib/blocks/create-fragment-from-block';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import { BlocksDocument } from '@intercom/embercom-prosemirror-composer';
import ComposerConfig from 'embercom/objects/workflows/graph-editor/chat-message/composer-config';
import type IntlService from 'ember-intl/services/intl';
import type Store from '@ember-data/store';
import type Owner from '@ember/owner';

interface ComposerArgs {
  step: $TSFixMe;
  attributeInfoResolver: $TSFixMe;
  enabledComposerTools: $TSFixMe;
  placeholder: string;
  inserters: $TSFixMe;
  onFocus: () => void;
}

export default class ProsemirrorAnswerTerminalComposer extends Component<ComposerArgs> {
  blocksDoc;
  @service declare intl: IntlService;
  @service declare appService: $TSFixMe;
  @service declare attributeService: $TSFixMe;
  @service declare store: Store;
  @service declare intercomEventService: $TSFixMe;
  @service declare contentEditorService: $TSFixMe;

  @tracked composerApi: $TSFixMe;
  @tracked openInserters: $TSFixMe;

  constructor(owner: Owner, args: ComposerArgs) {
    super(owner, args);
    this.blocksDoc = new BlocksDocument(this.args.step.blocks);
    this.openInserters = [];
  }

  get app() {
    return this.appService.app;
  }

  get composerConfig() {
    let config = new ComposerConfig({
      app: this.app,
      resolver: this.args.attributeInfoResolver,
      placeholder: this.placeholder,
    });
    if (this.args.enabledComposerTools) {
      config.tools = this.args.enabledComposerTools;
    }

    config.upload.onUploadStart = this.contentEditorService.uploadFileStarted;
    config.upload.onUploadFinish = this.contentEditorService.uploadFileFinished;

    return config;
  }

  get placeholder() {
    return this.args.placeholder
      ? this.args.placeholder
      : this.intl.t('operator.workflows.visual-builder.write-message-placeholder');
  }

  get controlsAPI() {
    return {
      app: this.app,
      actions: {
        registerOpenInserter: (inserterName: string) => {
          this.openInserters.pushObject(inserterName);
        },
        clearOpenInserter: (inserterName: string) => {
          if (!this.isDestroying) {
            this.openInserters.removeObject(inserterName);
          }
        },
        paste: (text: string) => {
          this.composerApi.composer.commands.insertText(text);
        },
        insertBlock: (type: string, block: $TSFixMe) => {
          block['type'] = type;
          this.composerApi.composer.commands.insertBlock(block);
        },
        uploadVideo: (files: $TSFixMe) => {
          let file = files && files.length > 0 && files[0];
          this.composerApi.composer.commands.insertVideoFile(file);
        },
        uploadAudio: (files: $TSFixMe) => {
          let file = files && files.length > 0 && files[0];
          this.composerApi.composer.commands.insertAudioFile(file);
        },
        uploadImage: (files: $TSFixMe) => {
          files.reverse().forEach((file: $TSFixMe) => {
            this.composerApi.composer.commands.insertImageFile(file);
            this.composerApi.composer.commands.collapseSelection();
          });
        },
        uploadAttachment: (files: $TSFixMe) => {
          files.forEach((file: $TSFixMe) => {
            this.composerApi.composer.commands.addAttachment(file);
          });
        },
      },
    };
  }

  @action
  updateBlocks(blocksDoc: $TSFixMe) {
    let store = this.store;
    let blockFragments = blocksDoc.blocks.map((block: $TSFixMe) =>
      createFragmentFromBlock(store, block),
    );
    this.args.step.blocks = blockFragments;
    // this is a known workaround to an issue with creating new fragments on a tracked model in a different component
    // without this `get serializedBlocks()` doesn't recompute and the chat message appears not to update
    this.args.step.notifyPropertyChange('blocks');
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Workflows::GraphEditor::NodeItems::Steps::AnswerTerminal::Composer': typeof ProsemirrorAnswerTerminalComposer;
    'workflows/graph-editor/node-items/steps/answer-terminal/composer': typeof ProsemirrorAnswerTerminalComposer;
  }
}
